import { useAppDispatch, useAppSelector } from '../../hooks';
import { useEffect, useState } from 'react';
import { GroupsSelectionList } from '../../components/RecipientsSelection/GroupsSelectionList';
import type { Group } from '../GroupsList/groupsSlice/types';
import { getGroups, getGroupsLoading } from './PanicButtonSlice';
import { fetchGroups } from './PanicButtonSlice/actionCreators';
import { EmptyListFallback } from '../../components/EmptyListFallback/EmptyListFallback';
import { selectUserId } from '../Login/LoginSlice';

type PanicGroupsListProps = {
  showActionButtons: boolean;
  selectedGroupsIdsList: number[];
  notSelectableGroupsIdsList: number[];
  isActive?: boolean;
  searchText?: string;
  onGroupClick: (group: Group) => void;
};

const GROUPS_PER_PAGE = 20;

export const PanicGroupsList = (props: PanicGroupsListProps) => {
  const {
    showActionButtons,
    selectedGroupsIdsList,
    notSelectableGroupsIdsList,
    isActive = true,
    searchText,
    onGroupClick,
  } = props;
  const dispatch = useAppDispatch();
  const groups = useAppSelector(getGroups);
  const groupsLoading = useAppSelector(getGroupsLoading);
  const userId = useAppSelector(selectUserId);
  const [page, setPage] = useState(0);

  const loadGroupsList = (pageNumber?: number, search?: string) => {
    const activePage = pageNumber ?? page ?? 0;
    const activeSearch = search ?? searchText ?? '';

    dispatch(
      fetchGroups({
        limit: GROUPS_PER_PAGE,
        offset: activePage * GROUPS_PER_PAGE,
        'name[match]': activeSearch,
        'membersCount[gte]': 2,
        ...(userId && { memberUserId: userId }),
      })
    );
  };

  useEffect(() => {
    if (isActive) {
      setPage(0);
      loadGroupsList(0);
    }
  }, [searchText]);

  useEffect(() => {
    if (!isActive) {
      setPage(0);
      loadGroupsList(0, '');
    }
  }, [isActive]);

  return (
    <>
      {isActive && (
        <GroupsSelectionList
          selectedGroupsIdsList={selectedGroupsIdsList}
          notSelectableGroupsIdsList={notSelectableGroupsIdsList}
          groups={groups}
          isLoading={groupsLoading}
          className={showActionButtons && groups.length > 5 ? 'lwtBottomPadding' : undefined}
          page={page}
          setPage={setPage}
          onGroupClick={onGroupClick}
          loadGroups={loadGroupsList}
          searchText={searchText}
          emptyListFallbackComponent={
            <EmptyListFallback
              listLength={groups?.length ?? 0}
              searchTerm={searchText}
              emptyListTx={'no_groups_found'}
              emptySearchTx={'groups_not_found_by_search'}
            />
          }
        />
      )}
    </>
  );
};
